import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { CSVLink } from 'react-csv';

import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components'
import { requestUsers, requestUsersDownload } from "../../../store/users/UsersActions";
import Pagination from '../../../components/common/Pagination';
import InfoBar from '../../../components/common/InfoBar';
import Moment from '../../../components/utils/Moment';
import { requestRolesTypeahead } from '../../../store/roles/RolesActions';
import RolesFilterForm from '../components/RolesFilterForm';
import { hostTitle } from '../../../config/ui';

const columns = [
  {
    Header: "FirstName",
    accessor: "firstName", 
  },
  {
    Header: "LastName",
    accessor: "lastName",
  },
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    Header: 'Organization',
    accessor: 'organization',
  },
  {
    Header: 'Active',
    accessor: 'isActive',
  },
  {
    Header: 'Roles',
    accessor: 'roleNames'
  },
  {
    Header: 'Clinics',
    accessor: 'clinicNames'
  },
  {
    Header: 'Last Activity',
    accessor: 'lastActivity',
  },
];

class UserManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 25, page: 0, pages: -1, search: null, sorted: [], roles: [], selectedOption: 0, dataToDownload: [] };
    this.handleChange = this.handleChange.bind(this);
    this.changeFilters = this.changeFilters.bind(this);
    this.download = this.download.bind(this);
  }

  handleChange(event) {
    this.setState({ selectedOption: event.target.value }, () => this.fetchData(this.state));
  }

  fetchData = state => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map(item => `${item.id} ${item.desc ? 'desc' : 'asc'}`)
      .join();
    const search = this.state.search;
    this.props.getUsersDownload({
      offset,
      limit,
      order,
      search,
      roles: state.roles ? state.roles.provider : [],
      showValue: this.state.selectedOption
    });
    return this.props.getUsers({
      offset,
      limit,
      order,
      search,
      roles: state.roles ? state.roles.provider : [],
        showValue: this.state.selectedOption
      }).then((response) => this.setState({
      pages:
        response.payload.data.total ? Math.ceil(
          response.payload.data.total / this.state.pageSize,
        )
        : 0
      }));
  };

  searchRoles = (search) => {
    return this.props
      .getRoles({
        offset: 0,
        limit: 10,
        order: '',
        search,
        filters: null
      })
      .then(result => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach(item => {
            options.push({ id: item.id, name: item.name });
          });
        }
        return options;
      });
  };

  changeFilters(params) {
    this.setState({ roles: { ...this.roles, ...params } }, () => this.fetchData(this.state));
  }

  editUser = (id, mode) => {
    hashHistory.push(`/user-management/user/${id}/${mode}`);
  };

  addUser = (id, mode) => {
    hashHistory.push(`/user-management/user/${id}/${mode}`);
  };

  setSearch = search => {
    return this.setState(
      {
        search,
        page: 0
      },
      () => this.fetchData(this.state),
    );
  };

  download() {
    const currentRecords = this.props.users.downloadUsers ? this.props.users.downloadUsers.list : [];

    currentRecords.forEach(item => {
      if (item.roles && item.roles.length > 0) {
        item.roleNames = item.roles.map(r => r.name).join();
      }
      if (item.clinics && item.clinics.length > 0) {
        item.clinicNames = item.clinics.map(r => r.name).join();
      }
    });

    var data_to_download = [];
    for (var index = 0; index < currentRecords.length; index++) {
      let record_to_download = {};
      for (var colIndex = 0; colIndex < columns.length; colIndex++) {
        record_to_download[columns[colIndex].Header] =
          currentRecords[index][columns[colIndex].accessor];
      }
      data_to_download.push(record_to_download);
    }
    this.setState({ dataToDownload: data_to_download }, () => {
      // click the CSVLink component to trigger the CSV download
      this.csvLink.link.click();
    });
  }

  render() {
    const { users } = this.props;
    return (
      <div id="content">
        <Helmet title={`User Management – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Administration', 'User Management']}
              icon="fa fa-fw fa-users"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={users.users.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>User Management</h2>
                </header>
                <div>
                  <div>
                    <CSVLink
                      data={this.state.dataToDownload}
                      filename="data.csv"
                      className="hidden"
                      ref={(r) => (this.csvLink = r)}
                      target="_blank"
                    />
                  </div>
                  <div className="widget-body no-padding">
                    <div className="row" >
                      <div className="col-md-1" >
                      </div>
                      <div className="col-md-1 text-right" style={{ padding: 5 }}>
                        <strong> Status Filter </strong>
                      </div>
                      <div className="col-md-3 form-inline">
                        <div className="form-group">
                          <select
                            className="form-control"
                            name="status"
                            value={this.state.selectedOption}
                            onChange={this.handleChange}
                          >
                            <option value="0">Show Active</option>
                            <option value="1">Show Inactive</option>
                            <option value="2">Show All</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-1 text-right" style={{ padding: 5 }}>
                        <strong> Role Filter </strong>
                      </div>
                      <div className="col-md-3" >
                        <RolesFilterForm searchRoles={this.searchRoles} onSubmit={this.changeFilters} />
                      </div>
                      <div className="col-md-3 text-right" style={{ paddingRight: 25 }}>
                        <button
                          className="btn btn-primary"
                          onClick={() => this.addUser('00000000-0000-0000-0000-000000000000', 'Add')}
                        > Create New User
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <button className="btn btn-primary" onClick={this.download}>Download</button>
                      </div>
                    </div>
                    
                    <ReactTable
                      manual
                      ref={(r) => (this.reactTable = r)}
                      page={this.state.page}
                      defaultPageSize={this.state.pageSize}
                      pages={this.state.pages}
                      loading={this.props.users.isLoading}
                      onFetchData={this.fetchData}
                      onPageSizeChange={pageSize => this.setState({ pageSize })}
                      onPageChange={page => this.setState({ page })}
                      onSortedChange={sorted => this.setState({ sorted })}
                      data={this.props.users ? this.props.users.users.list : []}
                      columns={[{
                          Header: '',
                          id: 'actions',
                          sortable: false,
                          width: 40,
                          Cell: row => (
                            <span>
                              <button
                                className="btn btn-xs btn-default"
                                onClick={() => this.editUser(row.original.id, 'Edit')}
                              >
                                <i className="fa fa-pencil" />
                              </button>
                              &nbsp;
                              <button className="btn btn-xs btn-default hide" disabled>
                                <i className="fa fa-times" />
                              </button>
                            </span>
                          ),
                        }, {
                          Header: 'Active',
                          sortable: false,
                          width: 40,
                          id: 'isActive',
                          accessor: d => d.isActive ? <i className="fa fa-check-circle-o"></i> : '',
                        }, {
                          Header: 'First Name',
                          id: 'firstName',
                          accessor: 'firstName',
                        }, {
                          Header: 'Last Name',
                          id: 'lastName',
                          accessor: 'lastName',
                        }, {
                          Header: 'Email',
                          accessor: 'email',
                        }, {
                          Header: 'Roles',
                          id: 'roles',
                          sortable: false,
                          accessor: d => {
                            if (d.roles && d.roles.length > 0) {
                              return d.roles.map(r => r.name).join();
                            }
                          },
                        }, {
                          Header: 'Organization',
                          id: 'organization',
                          accessor: 'organization',
                          sortable: false,
                        }, {
                          Header: 'Clinics',
                          id: 'clinic',
                          sortable: false,
                          accessor: d => {
                            if (d.clinics && d.clinics.length > 0) {
                              return d.clinics.map(r => r.name).join();
                            }
                          },
                        }, {
                          Header: 'Last Activity',
                          id: 'lastActivity',
                          accessor: d => (d.lastActivity && <Moment date={d.lastActivity} format="MM/DD/YYYY hh:mm" />),
                        },
                      ]}
                      showPaginationTop={true}
                      PaginationComponent={Pagination}
                      onSearchChange={this.setSearch}
                    />
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  state => ({
    users: state.users,
    roles: state.roles,
  }),
  dispatch => ({
    getUsers: params => dispatch(requestUsers(params)),
    getUsersDownload: params => dispatch(requestUsersDownload(params)),
    getRoles: params => dispatch(requestRolesTypeahead(params)),
  }),
)(UserManagement);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/UserManagement.js